import { Spacer } from 'app/member/layouts/generic';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { CampaignInformation } from './info';
import { SMSStatBar } from './statbar';

export const SMSViewPage = () => {
  const { id } = useParams();
  const [eligible_contacts, setEligibleContacts] = useState(0);

  return (
    <>
      <SMSStatBar id={id} eligible_contacts={eligible_contacts} />
      <Spacer multiple={4} />
      <CampaignInformation id={id} setEligibleContacts={setEligibleContacts} />
    </>
  );
};
